export const omitPathParameters = (
  params: Record<string, any> | undefined | null,
  url: string,
) => {
  if (!params) {
    return params;
  }
  return Object.keys(params).reduce((acc, paramName) => {
    if (url.includes("{" + paramName + "}")) {
      return acc;
    }
    return { [paramName]: params[paramName], ...acc };
  }, {});
};
export const replacePathParameters = (
  url: string,
  params: Record<string, any> | undefined | null,
) => {
  if (!params) {
    return url;
  }
  return Object.keys(params).reduce((acc, paramName) => {
    return acc.replace("{" + paramName + "}", params[paramName]);
  }, url);
};
